module.exports = __webpack_public_path__ + "static/media/taop.2f3232c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/taop.png
// module id = 32
// module chunks = 0